import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  padding: ${({ containerPadding }) => (containerPadding ? `${containerPadding}px` : "1em")}
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  border: ${({ primaryColor }) => `1px solid ${primaryColor}`};
  cursor: pointer;
  border-radius: ${({ roundedBorder }) => (roundedBorder ? "16px" : "8px")};
  && div {
    overflow: hidden;
  }
  && div:first-child {
    border-radius: ${({ roundedBorder }) => (roundedBorder ? "15px 0 0 15px" : "6px 0 0 6px")};
    border-right: ${({ primaryColor }) => `1px solid ${primaryColor}`};
  }
  && div:last-child {
    border-radius: ${({ roundedBorder }) => (roundedBorder ? "0 15px 15px 0" : "0 6px 6px 0")};
    border-left: ${({ primaryColor }) => `1px solid ${primaryColor}`};
  }
`;

const StyledToggle = styled.div`
  justify-content: center;
  align-items: center;
  color: ${({ optionIsSelected, primaryColor, secondaryColor }) => (optionIsSelected ? secondaryColor : primaryColor)};
  background-color: ${({ optionIsSelected, primaryColor, secondaryColor }) => (optionIsSelected ? primaryColor : secondaryColor)};
  width: 100%;
  text-align: center;
  padding: 0.4em;
  font-size: 14px;
  text-transform: ${({ textStyle }) => textStyle ?? ""};
`;

const GroupedButtons = ({
  options, // [{name, value}]
  selected,
  requireSelection = false,
  setFilter,
  primaryColor = "#005AA9",
  secondaryColor = "#FFFFFF",
  roundedBorder = false,
  textStyle,
  compareValue = false,
  containerPadding
}) => {
  const [selectedOption, setSelectedOption] = useState("");

  useEffect(() => {
    if (requireSelection && !selected) {
      setSelectedOption(options[0]?.name);
    }
  }, []);

  useEffect(() => {
    if (selected) {
      setSelectedOption(selected);
    }
  }, [selected]);

  return (
    <Container containerPadding={containerPadding}>
      <Wrapper primaryColor={primaryColor} roundedBorder={roundedBorder}>
        {
          options?.map(({ name = "", value = "" }, idx) => <StyledToggle
            key={idx}
            optionIsSelected={compareValue ? value === selectedOption : name === selectedOption}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            textStyle={textStyle}
            onClick={() => {
              setSelectedOption(compareValue ? value : name);
              setFilter(compareValue ? value : name);
            }}
          >
            {name}
          </StyledToggle>)
        }
      </Wrapper>
    </Container>
  );
};

export default GroupedButtons;
